module.exports = __webpack_public_path__ + "static/stephanie_brennan-17b111c821c0ada26118828cc97f50ba.png";